export default "__VITE_ASSET__DQJwCo57__"